module.exports = __webpack_public_path__ + "static/media/commenticon.5d43f0e7.svg";